import { useCheckList } from "./CheckListContext"
// import { useScenarioType } from "../ScenarioTypeContext"

const SaveChecklistButton = () => {
    const {showModal} = useCheckList()

    return (
        <div className="save-button-wrapper">
            <button
                className="save-btn"
                type="button"
                onClick={() => showModal()}
            >
                Save Changes
            </button>
        </div>
    )
}

export default SaveChecklistButton